import React from 'react';
import GridContainer from '../../../../../@jumbo/components/GridContainer';
import {
    Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent,
} from '@material-ui/core';

import { CustomToast } from '@jumbo/components/custom/Toast';
import { TEXT_COLOR_FT } from 'config/config';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
}));
const ModalUsarAut = (props) => {

    const classes = addStyle()

    const { onCloseDialog, openDialog, ponerDatos } = props

    return (
        <Dialog open={openDialog} onClose={onCloseDialog}>
            <CustomToast />
            <DialogTitle className={classes.dialogTitleRoot}>
                <Grid container justifyContent='space-between' style={{ color: TEXT_COLOR_FT }}>
                    <Grid item >

                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
                    <GridContainer style={{ color: TEXT_COLOR_FT }}>
                        {"¿Desea utilizar los datos de la autorización sanitaria?"}


                    </GridContainer>
                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog}>
                        {"NO"}
                    </Button>
                    <Box ml={2}>
                        {<Button variant="outlined" color="primary" onClick={() => {
                            ponerDatos()
                            onCloseDialog()
                        }}>
                            {'SI'}
                        </Button>
                        }

                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )

}

export default ModalUsarAut